export default __webpack_public_path__ + "static/media/RAM.23fb07bf.jpeg";